import { render, staticRenderFns } from "./premiumoffers-detail.vue?vue&type=template&id=78348810&"
import script from "./premiumoffers-detail.vue?vue&type=script&lang=js&"
export * from "./premiumoffers-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports